import axios from 'axios';
import { API } from 'configs/api';

const defaultBody = {
  grant_type: 'password',
  client_id: process.env.REACT_APP_CLIENT_ID,
  client_secret: process.env.REACT_APP_CLIENT_SECRET,
  scope: '*',
};
export const authService = {
  signIn: (body) => axios.post(API.signIn, { ...body, ...defaultBody }),

  userReg: (body) => axios.post(API.user, body),

  logOut: () => localStorage.removeItem('credentials'),

  getForgotPasswordLink: (email) => axios.post(API.forgotPasswordLink, { email }),

  changePasswordService: (data) =>
    axios.post(API.changePassword, data, { token: true }),

  userinfoService: () => axios.get(API.user, { token: true }),

  subscribe: (email) => axios.post(API.subscribe, { email }),

  newPassword: (body) => axios.post(API.newPassword, body),

  socialLogin: (body) => axios.post(API.socialLogin, body),

  emailVerify: (body) => axios.post(API.verifyEmail, body),

  socilaLoginEmailVerify: (body) => axios.post(API.socialLogin, body),

  sendCodeForgotPassword: (body) => axios.post(API.passwordRecoverCode, body),

  // UserinfoService: async () => {
  //   Const token = JSON.parse(localStorage.getItem('credentials'));
  //   Const headers = new Headers();
  //   Headers.append('Authorization', `Bearer ${token.access_token}`);
  //
  //   Const res = await fetch(
  //     'https://api-enjoy-your-life.baghdasarov.com/api/v1/user',
  //     { headers },
  //   );
  //   Return res.json();
  // },
};
